var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"mr-2"},[_c('b-badge',{attrs:{"pill":"","variant":"danger"}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('font-awesome-icon',{staticClass:"close-button",attrs:{"icon":"times"},on:{"click":function($event){return _vm.$emit('close-badge', _vm.badgeId)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }